import {FormProvider, useForm} from "react-hook-form";

import {EntityForm} from "base/entity/components/form";

const PermitExtensionTreesForm = ({extension, onSubmit = null, children}) => {
    const trees = extension?.tree_set;

    const formMethods = useForm({
        defaultValues: {
            trees: trees?.reduce((acc, tree) => {
                acc[tree.id] = {
                    is_felling_extended: tree.is_felling_extended || false,
                    is_cutting_extended: tree.is_cutting_extended || false,
                    number_of_logs_ext: tree.number_of_logs_ext || null,
                };
                return acc;
            }, {}),
        },
    });

    const {
        formState: {isDirty},
    } = formMethods;

    const handleSubmit = data => {
        if (onSubmit)
            onSubmit(
                Object.entries(data.trees).map(([treeId, values]) => ({
                    tree_id: Number(treeId),
                    is_felling_extended: !!values.is_felling_extended,
                    is_cutting_extended: !!values.is_cutting_extended,
                    number_of_logs_ext: values.is_cutting_extended
                        ? values.number_of_logs_ext
                        : null,
                }))
            );
    };

    return (
        <FormProvider {...formMethods}>
            <EntityForm
                onSubmit={onSubmit ? formMethods.handleSubmit(handleSubmit) : null}
                isFormDirty={isDirty}
            >
                {children}
            </EntityForm>
        </FormProvider>
    );
};

export default PermitExtensionTreesForm;
